import { createContext, useState, useEffect } from "react";
import User from "../interfaces/user";
import AuthContextProps from "../interfaces/AuthContextProps";

// En el caso que se refresque la página, se recupera el usuario actual y el token que se encuentra ubicado en LocalStorage
let sessionUser: User = localStorage.getItem('userInfo') ? 
            JSON.parse(`${localStorage.getItem('userInfo')}`)
            :
            null
            ;

//Creación del contexto de autenticación
export const AuthContext = createContext<AuthContextProps | null>(null);

/**
 * Propiedades para proveedor
 */
interface AuthProviderProps{
  children: any
}

/**
 * 
 * Proveedor de contexto de usuario actual
 * @author flynn1411
 * @date 06/03/23
 * @modified flynn1411
 * @date_modified 12/03/23
 */
const AuthProvider = ({children}: AuthProviderProps) => {
  const [currentUser, changeCurrentUser] = useState<User | null | undefined>(sessionUser);
  const api_url: string = 'https://cta-back-mwe4.onrender.com';

  const setCurrentUser = (newUser: User | null | undefined) => {
    changeCurrentUser(newUser);
    localStorage.setItem('userInfo', JSON.stringify(newUser));
  }

  const removeCurrentUser = () => {
    changeCurrentUser(null);
    //Se realiza el logout
    localStorage.removeItem('userInfo');
    localStorage.removeItem('USER_TOKEN');
  }

useEffect(() => {
  // Verifica si hay un usuario en localStorage al cargar el componente
  const storedToken = localStorage.getItem('USER_TOKEN');
  
  if (storedToken) {
    try {
      // Decode JWT payload
      const jwtPayload = JSON.parse(window.atob(storedToken.split('.')[1]));
      const expirationTime = jwtPayload.exp * 1000; // Convert to milliseconds
      const currentTime = Date.now();
      
      console.log('Token expiration time:', new Date(expirationTime).toLocaleString());
      console.log('Current time:', new Date(currentTime).toLocaleString());
      
      if (currentTime >= expirationTime) {
        console.log('Token has expired, logging out user');
        removeCurrentUser();
      } else {
        // Token is still valid - calculate remaining time
        const remainingTimeMs = expirationTime - currentTime;
        const remainingMinutes = Math.floor(remainingTimeMs / 60000);
        console.log(`Token is valid for ${remainingMinutes} more minutes`);
        
        // Optional: Set up automatic logout when token expires
        const timeoutId = setTimeout(() => {
          console.log('Token expired during session, logging out');
          removeCurrentUser();
        }, remainingTimeMs);
        
        // Clean up timeout if component unmounts
        return () => clearTimeout(timeoutId);
      }
    } catch (error) {
      console.error('Error validating token:', error);
      removeCurrentUser(); // Invalid token format, log out user
    }
  }
}, []);

  return(
    <AuthContext.Provider value={{currentUser, setCurrentUser, removeCurrentUser, api_url}}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;